import React, { useEffect, useState } from 'react';
import {
  Card,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Snackbar,
  Alert,
} from '@mui/material';
import ScheduleIcon from '@mui/icons-material/Schedule';
import DoneIcon from '@mui/icons-material/Done';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import { fetchNotifications,deleteAllNotifications,deleteNotification } from '../../reducers/notificationReducer';
import { useSelector,useDispatch } from 'react-redux';

const AdminNotifications = () => {
  const dispatch = useDispatch();
  const notifications = useSelector((state) => state.notifications?.list||[]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedNotificationId, setSelectedNotificationId] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  const navigate = useNavigate();

 useEffect(() => {
  dispatch(fetchNotifications());
}, [dispatch]);



  const handleMenuOpen = (event, Id) => {
    setAnchorEl(event.currentTarget);
    setSelectedNotificationId(Id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedNotificationId(null);
  };

 const handleDeleteNotification = async () => {
  if (!selectedNotificationId) return;
  try {
    dispatch(deleteNotification(selectedNotificationId));
   
    setSnackbar({
      open: true,
      message: 'Notification deleted successfully.',
      severity: 'success',
    });
  } catch (err) {
    setSnackbar({
      open: true,
      message: 'Failed to delete notification.',
      severity: 'error',
    });
  } finally {
    handleMenuClose();
  }
};

  const handleDeleteAll = async () => {
    try {
      dispatch(deleteAllNotifications());
      setSnackbar({
        open: true,
        message: ' notifications deleted Successfully.',
        severity: 'success',
      });
    } catch (err) {
      setSnackbar({
        open: true,
        message: 'Failed to delete notifications.',
        severity: 'error',
      });
    }
  };

  const handleNotificationClick = (id) => {
    navigate('/notificationdetails', {
      state: {
        notificationId: id,
        notifications: notifications,
      },
    });
  };

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  return (
    <Card sx={{ maxWidth: 600, margin: '2rem auto', padding: 2 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h6" gutterBottom>
          Notifications
        </Typography>

        <Box
          display="flex"
          alignItems="center"
          sx={{ cursor: 'pointer' }}
          onClick={handleDeleteAll}
        >
          <DeleteIcon fontSize="small" sx={{ mr: 0.5 }} />
          <Typography variant="body2" color="red">
            Delete All
          </Typography>
        </Box>
      </Box>

      {notifications.length === 0 ? (
        <Typography variant="body2" color="text.secondary" align="center">
          No notifications found.
        </Typography>
      ) : (
        <List>
          {notifications.map((note) => (
            <Box key={note.Id} component="li" sx={{ listStyle: 'none' }}>
              <ListItem
                alignItems="flex-start"
                sx={{
                  cursor: 'pointer',
                  backgroundColor: note.Status === 'Unread' ? 'lightblue' : '#fff',
                  '&:hover': {
                    backgroundColor: note.Status === 'Unread' ? '#add8e6' : '#f0f0f0',
                  },
                }}
              >
                <Box onClick={() => handleNotificationClick(note.Id)} sx={{ flexGrow: 1 }}>
                  <ListItemText
                    primary={
                      <Typography
                        variant="subtitle1"
                        fontWeight={note.Status === 'Unread' ? 'bold' : 'normal'}
                      >
                        {note.Title}
                      </Typography>
                    }
                    secondary={
                      <Typography
                        component="span"
                        variant="body2"
                        color="text.secondary"
                      >
                        {note.Comments}
                        <Box display="flex" alignItems="center" mt={0.5}>
                          <ScheduleIcon sx={{ fontSize: 16, mr: 0.5 }} />
                          <Typography variant="caption" color="text.secondary">
                            {new Date(note.created_at).toLocaleString()}
                          </Typography>
                        </Box>
                      </Typography>
                    }
                  />
                </Box>

                {note.Status === 'Read' && <DoneIcon color="success" fontSize="small" />}

                <IconButton edge="end" onClick={(e) => handleMenuOpen(e, note.Id)}>
                  <MoreVertIcon />
                </IconButton>
              </ListItem>
              <Divider />
            </Box>
          ))}
        </List>
      )}

      {/* Context Menu */}
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
        <MenuItem onClick={handleDeleteNotification}>
          <DeleteIcon fontSize="small" sx={{ mr: 1 }} />
          Delete
        </MenuItem>
      </Menu>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Card>
  );
};

export default AdminNotifications;
